<template>
  <div class="page trivia generic">
    <GenericHeader />
    <main>
      <section class="genericContent">
        <h1 class="genericContent__heading">Contact Us</h1>
        <h2 class="genericContent__h2">{{ siteData.company_name }}</h2>
        <ul class="genericContent__list">
          <li>{{ siteData.company_address }}</li>
          <li v-if="siteData.company_address2">
            {{ siteData.company_address2 }}
          </li>
          <li>
            {{ siteData.company_city }}, {{ siteData.company_state }} {{ siteData.company_zipcode }}
          </li>
          <li><a :href="`mailto:${siteData.company_contact_email}`">{{ siteData.company_contact_email }}</a></li>
          <li>{{ siteData.company_phone }}</li>
        </ul>
      </section>
    </main>
    <site-footer />
  </div>
</template>

<script>
import GenericHeader from "./GenericHeader.vue";
import SiteFooter from "../site/SiteFooter.vue";
import { mapState } from 'vuex';

export default {
  name: "Contact",
  components: {
    GenericHeader,
    SiteFooter
  },
  created() {
    this.$store.dispatch("GET_DATA");
  },
  computed: {
    ...mapState({
      siteData: state => state.data.site
    })
  }
};
</script>
